// TODO:  make a config file or setting
const ClearedChars = " \n\t\v\r$%#/&\\+:=*|".split("");

export default ClearedChars;
